import { render, staticRenderFns } from "./IconProfitability.vue?vue&type=template&id=2835d49a"
import script from "./IconProfitability.vue?vue&type=script&lang=js"
export * from "./IconProfitability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports